import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, filter, mapTo, startWith } from 'rxjs/operators';
import { isSubProject, Project } from 'src/app/classes/project.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog-service/confirm-dialog.service';
import { ProjectService } from 'src/app/services/project.service';
import { WeekreportPdfOptionsDialogComponent } from '../project-week-report-dialog/weekreport-pdf-options-dialog/weekreport-pdf-options-dialog.component';

@Component({
    selector: 'app-project-overview',
    templateUrl: './project-overview.component.html',
    styleUrls: ['./project-overview.component.scss'],
    standalone: false,
})
export class ProjectOverviewComponent extends CodaltComponent implements OnInit {
    // Beschikbaar maken voor de template, voor het inspringen van deelprojecten.
    protected readonly isSubProject = isSubProject;

    fcProjectId = new FormControl<string>('');
    projectSearch$ = new Subject<string>();
    searching = false;

    projectId: WritableSignal<string | null> = signal(null);

    projects: Project[];

    reports: {
        afas_project_id: string;
        projectComments: {
            week: number;
            year: number;
            user_minutes: number;
            entity_minutes: number;
            afas_project_id: string;
        }[];
    }[];

    pdfRequested = false;

    constructor(
        private projectService: ProjectService,
        private confirmDialog: ConfirmDialogService,
        private dialog: MatDialog,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.projectSearch$.pipe(startWith(''), debounceTime(400)).subscribe(searchProjectId => {
                this.getProjects(searchProjectId);
                this.searching = searchProjectId?.length > 0;
            })
        );

        this.subscriptions.add(
            this.fcProjectId.valueChanges.subscribe(projectId => {
                this.projectId.set(projectId);
                this.pdfRequested = false;
                this.projectService.getReports(projectId).subscribe(reports => {
                    this.reports = [];
                    const projects = Array.from(new Set(reports.data.map(report => report.afas_project_id)));
                    projects.forEach(projectId => {
                        this.reports.push({
                            afas_project_id: projectId,
                            projectComments: reports.data.filter(report => report.afas_project_id === projectId),
                        });
                    });
                });
            })
        );

        this.subscriptions.add(
            this.route.queryParamMap.subscribe(params => {
                const projectId = params.get('projectId');
                if (projectId) {
                    this.fcProjectId.setValue(projectId);

                    this.fcProjectId.updateValueAndValidity();
                }
            })
        );
    }

    makeReport() {
        const dialogRef = this.dialog.open(WeekreportPdfOptionsDialogComponent, {
            data: {
                projectId: this.fcProjectId.value,
                combine: true,
            },
        });

        this.subscriptions.add(
            dialogRef
                .afterClosed()
                .pipe(
                    filter(result => result === true),
                    mapTo(true)
                )
                .subscribe(success => {
                    if (success) {
                        this.pdfRequested = true;
                    }
                })
        );
    }

    private getProjects(searchProjects?: string) {
        this.subscriptions.add(
            this.projectService.searchProjects(searchProjects, {}, !!searchProjects).subscribe(projects => {
                this.projects = projects.data;
            })
        );
    }
}
